import React, { useState, useEffect } from 'react';
import { Image } from "react-bootstrap";
import { firestore } from '../../firebase/firebase-utils';
import Pagination from '../../Text-Editor/Pagination'

function SearchResults(props) {
    const [searchTopic, setSearchTopic] = useState('')
    const [searchResults, setSearchResults] = useState([])
    const [Loading, setLoading] = useState(false);
    const [CurrentPage, setCurrentPage] = useState(1);
    const PostsPerPage = 10;

    const getResults = () => {
        let query = new URLSearchParams(props.location.search)
        let Topic = '';
        for (let param of query.entries()) {
            Topic = param[1]
        }
        setSearchTopic(Topic);
        setLoading(true);
        firestore.collection('technews').get()
            .then(querySnapshot => {
                // eslint-disable-next-line
                var results = querySnapshot.docs.map(doc => {
                    var count = doc.data().keys.reduce((acc, elem) => {
                        return elem === Topic ? acc + 1 : acc
                    }, 0)
                    if (count !== 0) {
                        return {
                            ...doc.data(),
                            id: doc.id
                        }
                    }
                })
                results = results.filter(result => (result !== undefined))
                setSearchResults(results.slice(0,150))
                setLoading(false);
            })
    }

    // get current page posts
    const indexOfLastPost = CurrentPage * PostsPerPage;
    const indexOfFirstPost = indexOfLastPost - PostsPerPage;
    const currentPosts = searchResults.slice(indexOfFirstPost, indexOfLastPost);

    //setting current page
    const setCurrent = (e) => {
        setCurrentPage(e)
    }

    useEffect(() => {
        getResults()
        // eslint-disable-next-line
    }, [props.location.search]);

    const getFullPost = (id) => {
        props.history.push('/technews/' + id)
    }

    return (
        <>
            {Loading ? "loading..." : ''}
            <div style={{ minHeight: '70vh' }}>
                <h4 style={{ marginBottom: '20px' }}>Topic : &nbsp;&nbsp;<strong style={{ fontFamily: 'Poppins' }}>{searchTopic}</strong></h4>
                {currentPosts.map((feed) => (
                    <div key={feed.query} onClick={() => getFullPost(feed.id)} className="hoverCard">
                        <Image className="Img" src={feed.img} fluid />
                        <div style={{ paddingLeft: '10px' }}>
                            <h6>{feed.title}</h6>
                            <p className="author">Author: <span style={{ color: 'blue' }}>{feed.author}</span></p>
                        </div>
                    </div>
                ))
                }
            </div>
            <br />
            <div >
                <Pagination totalPosts={searchResults.length} postsPerPage={PostsPerPage} setCurrentPage={setCurrent} />
            </div>
        </>
    );

}

export default SearchResults;